import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Atol5PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ATOL5;
}

export default Atol5PoiTileEntity;
